import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef } from 'react';
import classNames from 'classnames';
import { styled } from '@miro-site/ui-styled-engine';
import { Grid, GridItem, Plus, Typography, Section } from '@miro-site/ui-core';
import JSONLD from './JsonLD';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FAQGridItem = styled(GridItem, {
  backgroundColor: '$blue-10',
  padding: '$200',
  borderRadius: '$100',
  transition: 'height 0.3s ease-in-out',
  '@md': {
    padding: '$300'
  },
  '@xl': {
    padding: '$400'
  },
  '.question-wrapper': {
    display: 'flex',
    justifyContent: 'space-between',
    svg: {
      transform: 'rotate(45deg)',
      transition: 'transform 0.3s ease-in-out'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  },
  '.faq-answer': {
    transition: 'all 0.3s ease-in-out',
    maxHeight: '500px',
    overflow: 'auto'
  },
  '&.collapsed': {
    '.faq-answer': {
      opacity: 0,
      maxHeight: '0px',
      marginTop: 0
    },
    '.question-wrapper': {
      svg: {
        transform: 'rotate(0deg)'
      }
    }
  }
});

var FAQ = function FAQ(props) {
  var _props$faqs2;

  var referenceContainer = useRef();

  var generateJSONLDProps = function generateJSONLDProps() {
    var _props$faqs;

    var finalJson = {
      mainEntity: []
    };
    props === null || props === void 0 ? void 0 : (_props$faqs = props.faqs) === null || _props$faqs === void 0 ? void 0 : _props$faqs.forEach(function (item) {
      finalJson.mainEntity.push({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      });
    });
    return finalJson;
  };

  var toggleItem = function toggleItem(index) {
    return function () {
      var _referenceContainer$c, _referenceContainer$c2;

      (_referenceContainer$c = referenceContainer.current.querySelector(".faq-item-".concat(index))) === null || _referenceContainer$c === void 0 ? void 0 : (_referenceContainer$c2 = _referenceContainer$c.classList) === null || _referenceContainer$c2 === void 0 ? void 0 : _referenceContainer$c2.toggle('collapsed');
    };
  };

  return /*#__PURE__*/_jsx(Section, {
    pageTopInset: "1200",
    children: /*#__PURE__*/_jsxs("div", {
      ref: referenceContainer,
      children: [/*#__PURE__*/_jsx(JSONLD, _objectSpread({
        type: "FAQPage"
      }, generateJSONLDProps())), props.title != '' && /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsx(GridItem, {
          columnStart: "1",
          columnEnd: {
            '@initial': '-1',
            '@sm': 7
          },
          children: /*#__PURE__*/_jsx(Typography, {
            tag: "h2",
            type: "heading",
            variant: "heading-2",
            offsetBottom: {
              '@initial': '600',
              '@lg': '800'
            },
            children: props.title
          })
        })
      }), props === null || props === void 0 ? void 0 : (_props$faqs2 = props.faqs) === null || _props$faqs2 === void 0 ? void 0 : _props$faqs2.map(function (item, index) {
        var _classNames;

        return /*#__PURE__*/_jsx(Grid, {
          css: {
            marginBottom: '$200'
          },
          children: /*#__PURE__*/_jsx(FAQGridItem, {
            xs: 12,
            asChild: true,
            children: /*#__PURE__*/_jsxs("div", {
              className: classNames((_classNames = {}, _defineProperty(_classNames, "faq-item-".concat(index), true), _defineProperty(_classNames, "collapsed", index !== 0), _classNames)),
              children: [/*#__PURE__*/_jsxs("div", {
                onClick: toggleItem(index),
                className: "question-wrapper",
                children: [/*#__PURE__*/_jsx(Typography, {
                  tag: "h3",
                  type: "heading",
                  variant: "heading-4",
                  className: "faq-question",
                  renderChildrenAsHTML: true,
                  children: (item === null || item === void 0 ? void 0 : item.question) || ''
                }), /*#__PURE__*/_jsx("div", {
                  className: "svg-wrapper",
                  children: /*#__PURE__*/_jsx(Plus, {
                    color: "defaultSelected"
                  })
                })]
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "body-text-1",
                className: "faq-answer",
                offsetTop: {
                  '@initial': '200',
                  '@md': '300',
                  '@xl': '400'
                },
                renderChildrenAsHTML: true,
                children: (item === null || item === void 0 ? void 0 : item.answer) || ''
              })]
            })
          })
        }, 'faq-' + index);
      })]
    })
  });
};

export default FAQ;